import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function EnergyBarChart({ rawData }) {
  const getValue = (key, divisor = 1) =>
    (rawData.find((item) => item.name === key)?.value || 0) / divisor;

  const getCount = (key) =>
    rawData.find((item) => item.name === `${key}_Number_Of_Active_Assets`)?.value || 0;

  const data = [
    {
      name: "Energietypen",
      PV: getValue("PV_Total_Power", 1000),
      PV_count: getCount("PV"),
      WP: getValue("WP_Total_Power", 1000),
      WP_count: getCount("WP"),
      HP: getValue("HP_Total_Power", 1000),
      HP_count: getCount("HP"),
      BM: getValue("BM_Total_Power", 1000),
      BM_count: getCount("BM"),
      Conventional: getValue("Conventional_Total_Power", 1000),
      Conventional_count: getCount("Conventional"),
    },
  ];

  const COLORS = {
    PV: "#ffcd00",
    WP: "#1E90FF",
    HP: "#40E0D0",
    BM: "#8B4513",
    Conventional: "#D3D3D3",
  };

  const LABELS = {
    PV: "Solare Strahlungsenergie",
    WP: "Windkraft",
    HP: "Wasserkraft",
    BM: "Biomasse",
    Conventional: "Nicht erneuerbare Energie",
  };

  // Custom Tooltip zeigt NUR den aktuellen Punkt
const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;

  const entry = payload[0];
  const { dataKey, value, fill, payload: fullPayload } = entry;
  const assetCount = fullPayload[`${dataKey}_count`] || 0;
  const unit = dataKey === "PV" ? "MWp" : "MW";

  return (
    <div className="bg-white border border-gray-300 p-2 rounded text-sm text-black text-left">
        <p className="font-semibold">{LABELS[dataKey]}</p>
        <p>Installierte Leistung: {value.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}{" "}
        {unit}</p>
      <p>Anzahl der Anlagen: {assetCount.toLocaleString("de-DE")} </p>
    </div>
  );
};


  // Custom Legend: Text schwarz, zentriert
  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          flexWrap: "wrap",
          gap: 15,
          fontSize: 14,
          color: "black",
        }}
        aria-label="Legende der Energieträger"
      >
        {payload.map((entry) => (
          <div
            key={entry.value}
            style={{ display: "flex", alignItems: "center", cursor: "default" }}
          >
            <div
              style={{
                width: 16,
                height: 16,
                backgroundColor: entry.color,
                marginRight: 6,
                border: "1px solid #00000055",
              }}
            />
            <span>{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      className="mt-4 p-4 bg-white rounded-lg flex justify-center items-center"
      style={{ height: 100 }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
        >
          <XAxis
            type="number"
            hide
            domain={[0, "dataMax"]}
            allowDecimals={false}
            tick={false}
          />
          <YAxis type="category" dataKey="name" hide />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
            wrapperStyle={{ outline: "none" }}
            shared={false}
          />
          <Legend content={renderLegend} />
          {Object.keys(LABELS).map((key) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="a"
              fill={COLORS[key]}
              name={LABELS[key]}
              barSize={40}
              isAnimationActive={false}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default EnergyBarChart;
